<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BContainer
      fluid
    >
      <BRow>

        <BCol
          cols="12"
          class="px-1"
        >
          <BFormGroup
            label="Search"
            label-for="filterGroupSearch"
            label-class="font-weight-bolder"
          >
            <BFormInput
              id="filterGroupSearch"
              v-model="tableCategories.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          class="px-1 mb-2"
        >
          <BButton
            size="sm"
            type="button"
            variant="primary"
            @click.prevent="createGroup"
          >
            Add Group
          </BButton>
        </BCol>

      </BRow>

      <BRow
        class="mt-1"
      >
        <BCol
          cols="12"
          class="px-1"
        >
          <BTable
            ref="tableCategories"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :items="tableProvider"
            :busy="tableCategories.busy"
            :filter="tableCategories.filter"
            :fields="tableCategories.fields"
            :stacked="tableCategories.stacked"
            :sort-by.sync="tableCategories.sortBy"
            :sort-desc.sync="tableCategories.sortDesc"
            :sort-direction="tableCategories.sortDirection"
            :filter-included-fields="tableCategories.filterOn"
            :current-page="tableCategories.currentPage"
            :per-page="tableCategories.perPage"
          >
            <template #cell(index)="{ index }">
              {{ tableRowNumber(tableCategories, index) }}
            </template>

            <template #cell()="{ value }">
              <div class="text-md-nowrap">
                {{ value }}
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <BButton
                  size="sm"
                  variant="primary"
                  @click.prevent="editGroup(item)"
                >
                  Edit
                </BButton>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <BIcon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </BTable>
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <BFormSelect
            v-model="tableCategories.perPage"
            :options="tableCategories.pageOptions"
            :disabled="tableCategories.busy"
            class="w-100 w-md-25"
            size="sm"
          />
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <BPagination
            v-model="tableCategories.currentPage"
            :total-rows="tableCategories.totalRows"
            :per-page="tableCategories.perPage"
            :disabled="tableCategories.busy"
            aria-controls="table"
            prev-text="Prev"
            next-text="Next"
            first-number
            last-number
            pills
          />
        </BCol>
      </BRow>

    </BContainer>

    <BModal
      id="modalGroup"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      title="Edit Group"
      aria-hidden="false"
    >
      <ValidationObserver
        ref="formGroup"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="group code"
                vid="group_code"
                rules="required|max:100"
              >
                <BFormGroup
                  label="Code"
                  label-for="group_code"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="group_code"
                    v-model="group.group_code"
                    type="text"
                    maxlength="30"
                    autocomplete="off"
                    placeholder="enter group code here"
                    :state="(errors.length > 0 ? false : null)"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="group name"
                vid="group_name"
                rules="required|max:100"
              >
                <BFormGroup
                  label="Name"
                  label-for="group_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="group_name"
                    v-model="group.group_name"
                    type="text"
                    maxlength="100"
                    autocomplete="off"
                    placeholder="enter group name here"
                    :state="(errors.length > 0 ? false : null)"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
            <BCol
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="is_active"
                  v-model="group.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="validateGroup"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </BButton>
        <BButton
          variant="outline-dark"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="$event => {
            $event.target.blur()
            cancel()
          }"
        >
          Close Window
        </BButton>
      </template>

    </BModal>
  </BContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import QUERY from 'lodash'
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { SAdminGroup } from '@/services/admin'

export default {
  name: 'VAdminGroups',

  middleware: [
    'auth',
    'admin'
  ],

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Categories'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      group: {
        id: '',
        group_code: '',
        group_name: '',
        active: 1
      },
      tableCategories: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 6, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'group_code', class: 'min-w-175px' },
          { mobile: 3, key: 'group_name', class: 'min-w-175px' },
          { mobile: 4, key: 'active', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 5, key: 'updated_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableCategories.busy = true
      return await SAdminGroup.get({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search
      }).then(({ data }) => {
        this.tableCategories.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        this.tableCategories.totalRows = 0
        return []
      }).finally(() => {
        this.tableCategories.busy = false
      })
    },

    createGroup () {
      this.state.editing = false

      this.group.id = ''
      this.group.group_code = ''
      this.group.group_name = ''
      this.group.active = 1

      this.$bvModal.show('modalGroup')
    },

    editGroup (group) {
      this.state.editing = true

      this.group.id = group.id
      this.group.group_code = group.group_code
      this.group.group_name = group.group_name
      this.group.active = group.active

      this.$bvModal.show('modalGroup')
    },

    async validateGroup () {
      await this.$refs.formGroup.validate().then(
        async validGroup => {
          if (!validGroup) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: () => {
              if (this.state.editing) {
                return '<h6>Save your changes on this Group?</h6>'
              }
              return '<h6>Create this Group?</h6>'
            },
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.updateGroup()
              }
              return this.submitGroup()
            }
          })
        }
      )
    },

    async submitGroup () {
      return await SAdminGroup.post(this.group).then(
        ({ data: { message } }) => {
          this.$bvModal.hide('modalGroup')
          this.swalSuccess(message).then(() => {
            this.$refs.tableCategories.refresh()
          })
        }
      ).catch(({ message }) => {
        this.$refs.formGroup.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    },

    async updateGroup () {
      this.state.busy = true
      return await SAdminGroup.put(this.group).then(
        ({ data: { message, group } }) => {
          this.$bvModal.hide('modalGroup')
          this.swalSuccess(message).then(() => {
            const tableCategoriesRow = QUERY.find(this.$refs.tableCategories.localItems, {
              id: Number(group.id)
            })
            if (tableCategoriesRow) {
              tableCategoriesRow.group_code = group.group_code
              tableCategoriesRow.group_name = group.group_name
              tableCategoriesRow.active = group.active
              tableCategoriesRow.updated_at = group.updated_at
            }
          })
        }
      ).catch(({ message }) => {
        this.$refs.formGroup.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
